module.exports = __webpack_public_path__ + "static/media/graph_background.c054d721.jpg";